import { ENTITIES, PRODUCT_STATUS } from './constants';

export const isProductInactive = product => product.status === PRODUCT_STATUS.INACTIVE;

export const isProductCheckedOrInactive = product => product.checked || isProductInactive(product);

export const isAnyProductActive = products =>
  products.some(product => product.status === PRODUCT_STATUS.ACTIVE);

export const isAllUnchecked = products => {
  return products.every(p => !p.checked);
};

export const toggleCategory = ({ categoryId, categories }) => {
  return categories.map(cat => {
    const allUnchecked = isAllUnchecked(cat.products);
    return cat.id === categoryId
      ? {
          ...cat,
          products: cat.products.map(prod => ({
            ...prod,
            checked: allUnchecked,
          })),
        }
      : cat;
  });
};

export const toggleProduct = ({ categoryId, productId, categories }) => {
  return categories.map(cat =>
    cat.id === categoryId
      ? {
          ...cat,
          products: cat.products.map(prod =>
            prod.id === productId
              ? {
                  ...prod,
                  checked: !prod.checked,
                }
              : prod
          ),
        }
      : cat
  );
};

export const changeQuantity = ({ categoryId, productId, quantity, categories }) => {
  return categories.map(cat =>
    cat.id === categoryId
      ? {
          ...cat,
          products: cat.products.map(prod =>
            prod.id === productId
              ? {
                  ...prod,
                  quantity,
                }
              : prod
          ),
        }
      : cat
  );
};

export const clearProductsSelection = categories => {
  return categories.map(cat => ({
    ...cat,
    products: cat.products.map(prod => ({
      ...prod,
      checked: false,
      quantity: null,
    })),
  }));
};

export const getOnlyCheckedProducts = categories =>
  categories.reduce(
    (products, cat) => [...products, ...cat.products.filter(prod => prod.checked)],
    []
  );

export const getCategoriesChecked = (products, categories) => {
  return categories.map(cat => ({
    ...cat,
    checked: cat.products.every(prod => products.some(p => p.id === prod.id)),
    products: cat.products.map(prod => ({
      ...prod,
      checked: products.some(p => p.id === prod.id),
    })),
  }));
};

export const normalizeTags = tags =>
  tags.map(tag => ({
    id: tag.id,
    title: tag.title,
  }));

export const normalizeSelectedTags = tags => {
  if (!tags) {
    return [];
  }

  return tags.reduce((arr, tag) => [...arr, tag.id], []);
};

export const formatSelectedTags = (tags, selectedTags) => {
  if (selectedTags.length === 0) {
    return null;
  }

  return normalizeTags(
    tags.filter(tag => selectedTags.some(selectedTag => tag.id === selectedTag))
  );
};

export const formatProductsToBeDeleted = modalData => {
  const { product, categories, products } = modalData;
  let data = {};

  if (product) {
    if (product.idCategory) {
      data = {
        categories: [product.idCategory],
        products: [],
      };
    } else {
      data = {
        categories: [],
        products: [
          {
            categoryId: product.categoryId,
            products: [product.id],
          },
        ],
      };
    }
  } else {
    data = {
      products: products && products.length ? products : [],
      categories: categories && categories.length ? categories : [],
    };
  }
  return data;
};

export const isSomeProductChecked = (categories = [], categoryId = null) => {
  return !!categories.find(
    cat => (!categoryId || cat.id === categoryId) && cat.products.some(prod => prod.checked)
  );
};

export const isCheckedAllProducts = (categories = []) => {
  let isAllChecked = true;

  categories.forEach(cat => {
    if (!cat.checked && isAnyProductActive(cat.products)) {
      isAllChecked = false;
      return;
    }

    if (isAllChecked) {
      isAllChecked = cat.products.every(p => isProductCheckedOrInactive(p));
    }
  });

  return isAllChecked;
};

export const formatSearchProductsList = categories => {
  let entities = [];

  categories.forEach(cat => {
    entities.push({
      id: cat.id,
      name: cat.name,
      entity: ENTITIES.CATEGORY,
    });

    if (cat.products && cat.products.length) {
      entities = entities.concat(
        cat.products.map(prod => ({
          id: prod.id,
          name: prod.name,
          categoryId: prod.categoryId,
          entity: ENTITIES.PRODUCT,
        }))
      );
    }
  });

  return entities;
};

export const filterSearchProducts = (categories, searchOptions) => {
  const isCatSearched = cat =>
    searchOptions.some(opt => opt.id === cat.id && opt.entity === ENTITIES.CATEGORY);

  const isSomeProdChecked = cat =>
    searchOptions.some(
      opt => opt.entity === ENTITIES.PRODUCT && cat.products.some(prod => prod.id === opt.id)
    );

  const isProductSelected = prod =>
    searchOptions.some(opt => opt.entity === ENTITIES.PRODUCT && opt.id === prod.id);

  return categories
    .filter(cat => isCatSearched(cat) || isSomeProdChecked(cat))
    .map(cat => ({
      ...cat,
      products: !isSomeProdChecked(cat)
        ? cat.products
        : cat.products.filter(prod => isProductSelected(prod)),
    }));
};



// WEBPACK FOOTER //
// ./src/helpers/products.js